var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgCrown(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M16.527 4.969l.235.562 2.437 4.828c.422.844 1.547 1.079 2.297.516l3.375-2.719.797-.656c-.234-.281-.375-.703-.375-1.125A1.88 1.88 0 0127.168 4.5a1.88 1.88 0 011.875 1.875 1.851 1.851 0 01-1.875 1.875h-.047l-.187 1.125-1.97 10.688c-.233 1.406-1.5 2.437-2.952 2.437H9.027c-1.453 0-2.718-1.031-2.953-2.438L4.152 9.376 3.918 8.25c-1.078 0-1.875-.797-1.875-1.875A1.85 1.85 0 013.918 4.5a1.88 1.88 0 011.875 1.875c0 .422-.14.844-.375 1.125l.797.656 3.375 2.719c.75.563 1.828.328 2.25-.516l2.437-4.828.282-.562c-.563-.328-.891-.89-.891-1.594A1.85 1.85 0 0115.543 1.5a1.872 1.872 0 01.984 3.469zM8.277 19.64c.094.375.375.609.75.609h12.985c.375 0 .656-.234.75-.61l1.453-8.109-1.36 1.078c-1.828 1.5-4.593.891-5.671-1.265l-1.641-3.281-1.688 3.28c-1.078 2.157-3.843 2.766-5.671 1.266l-1.36-1.078 1.453 8.11z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgCrown);
export default ForwardRef;
